import React, { PropTypes } from 'react';

const SendButton = (props) => {
    const { app, actions } = props;

    const clientSend = () => {
        if (app.email) {
            actions.clientSend();
        } else {
            actions.setModal('EMAIL');
        }
    };

    const onChangeEmail = (e) => {
        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        if (validateEmail(e.target.value)) {
            actions.setAppEmail(e.target.value);
        }
    };

    return (
        <span className="nav-btns__next" onClick={clientSend}>SEND</span>
    );
};

SendButton.propTypes = {
    app: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
};

export default SendButton;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Content/UI/NavButtons/Send.jsx